import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK } from 'react-admin';
import { API_URL } from 'services/dataProvider';
import * as Sentry from '@sentry/browser';

const clearAuthLocalStorageInfo = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('isBusinessManager');
  localStorage.removeItem('ownConsultantSkillSet');
  localStorage.removeItem('ownSubsidiary');
};

export default () => async (type: any, params: any) => {
  if (type === AUTH_LOGIN) {
    const { username, password } = params;
    console.log('AUTH_LOGIN: Attempting login for user:', username);

    const request = new Request(`${API_URL}/auth/jwt/create/`, {
      method: 'POST',
      body: JSON.stringify({ email: username, password }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });

    const response = await fetch(request);
    if (response.status < 200 || response.status >= 300) {
      console.error(
        'AUTH_LOGIN: Login failed with status:',
        response.status,
        'for user:',
        username,
      );
      Sentry.withScope(scope => {
        const fingerprintParams = ['POST', '/auth/jwt/create/', response.status].map(String);
        scope.setFingerprint(fingerprintParams);
        const message = fingerprintParams.join(' ');
        Sentry.addBreadcrumb({
          level: Sentry.Severity.Warning,
          category: 'authent error',
          message: fingerprintParams.join(' '),
          data: { requestBody: { email: username, passwordLength: password.length }, response },
        });
        Sentry.captureEvent(new Error(message));
      });
      throw new Error(response.statusText);
    }
    const jsonResponse = await response.json();
    const { access, is_business_manager, consultant_skill_set, subsidiary } = jsonResponse;

    console.log('AUTH_LOGIN: Login successful for user:', username, {
      is_business_manager,
      consultant_skill_set,
      subsidiary,
    });

    if (!consultant_skill_set) {
      console.warn('AUTH_LOGIN: User has no consultant skill set:', username);
    }

    Sentry.setUser({ username });

    localStorage.setItem('token', access);
    localStorage.setItem('isBusinessManager', is_business_manager);
    localStorage.setItem('ownConsultantSkillSet', consultant_skill_set);

    // We need to use both localStorage and component state to :
    //  - force the app to rerender with new theme when subsidiary change (local state)
    //  - have access to it every where (local storage)
    localStorage.setItem('ownSubsidiary', subsidiary);

    console.log('AUTH_LOGIN: Authentication data stored in localStorage');
    return Promise.resolve();
  }

  if (type === AUTH_LOGOUT || type === AUTH_ERROR) {
    console.log('AUTH_LOGOUT/AUTH_ERROR: Clearing authentication data');
    clearAuthLocalStorageInfo();
    // window.location.href = '/';
    return Promise.resolve();
  }

  if (type === AUTH_CHECK) {
    const token = localStorage.getItem('token');
    if (token) {
      console.log('AUTH_CHECK: Token found, user is authenticated');
      return Promise.resolve();
    }

    console.log('AUTH_CHECK: No token found, user is not authenticated');
    return Promise.reject();
  }

  console.error('AUTH_PROVIDER: Unknown authentication method:', type);
  return Promise.reject('Unknown method');
};
